import React, { createContext, useContext, useMemo, useState } from 'react'
import type { KibSuperSelectOption } from '@chewy/kib-fields-new-react'
import type { Nil } from '@pbt/pbt-ui-components'

interface ChatContainerContextType {
  pendingSelection: KibSuperSelectOption | Nil
  setPendingSelection: (selection: KibSuperSelectOption | null) => void
}

const ChatContainerContext = createContext<
  ChatContainerContextType | undefined
>(undefined)

export const ChatContainerProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [pendingSelection, setPendingSelection] =
    useState<KibSuperSelectOption | null>(null)

  const contextValue = useMemo(
    () => ({
      pendingSelection,
      setPendingSelection,
    }),
    [pendingSelection, setPendingSelection],
  )

  return (
    <ChatContainerContext.Provider value={contextValue}>
      {children}
    </ChatContainerContext.Provider>
  )
}

export const useChatContainer = (): ChatContainerContextType => {
  const context = useContext(ChatContainerContext)
  if (context === undefined) {
    throw new Error(
      'useChatContainer must be used within a ChatContainerProvider',
    )
  }
  return context
}
